import React from 'react';
import { useSelector } from 'react-redux';
import { makeStyles } from 'tss-react/mui';
import { STATS_POPOVER_POSITION, THUMBNAIL_TYPE } from '../../constants';
import { getTopIndicatorsTooltipPosition } from '../../functions.web';
import RaisedHandIndicator from './RaisedHandIndicator';
import ConnectionIndicator from "../../../connection-indicator/components/web/ConnectionIndicator";
import { isScreenShareParticipantById } from "../../../base/participants/functions";
import StatusIndicatorsMobile from "./StatusIndicatorsMobile";
const useStyles = makeStyles()(() => {
    return {
        container: {
            display: 'flex',
            width: '100%',
            justifyContent: 'space-between',
            '& > *:not(:last-child)': {
                marginRight: '4px'
            }
        }
    };
});
const ThumbnailTopIndicatorsMobile = ({ disableConnectionIndicator, indicatorsClassName, participantId, thumbnailType }) => {
    const { classes: styles, cx } = useStyles();
    const { NORMAL = 16 } = interfaceConfig.INDICATOR_FONT_SIZES || {};
    const _indicatorIconSize = NORMAL;
    const _connectionIndicatorAutoHideEnabled = Boolean(useSelector((state) => state['features/base/config'].connectionIndicators?.autoHide) ?? true);
    const _connectionIndicatorDisabled = disableConnectionIndicator
        || Boolean(useSelector((state) => state['features/base/config'].connectionIndicators?.disabled));
    const showConnectionIndicator = !_connectionIndicatorAutoHideEnabled;
    const isVirtualScreenshareParticipant = useSelector((state) => isScreenShareParticipantById(state, participantId));
    if (isVirtualScreenshareParticipant) {
        return (React.createElement("div", { className: styles.container }, !_connectionIndicatorDisabled
            && React.createElement(ConnectionIndicator, { alwaysVisible: showConnectionIndicator, enableStatsDisplay: true, iconSize: _indicatorIconSize, participantId: participantId, statsPopoverPosition: STATS_POPOVER_POSITION[thumbnailType] })));
    }
    const tooltipPosition = getTopIndicatorsTooltipPosition(thumbnailType);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: styles.container },
            React.createElement("div", { style: {
                    display: 'flex',
                    gap: '8px',
                } },
                thumbnailType === THUMBNAIL_TYPE.TILE && (React.createElement("div", { className: cx(indicatorsClassName, 'top-indicators') },
                    React.createElement(StatusIndicatorsMobile, { participantID: participantId, moderator: true, screenshare: false }))),
                React.createElement(RaisedHandIndicator, { iconSize: _indicatorIconSize, participantId: participantId, tooltipPosition: tooltipPosition })),
            thumbnailType === THUMBNAIL_TYPE.TILE && !_connectionIndicatorDisabled && (React.createElement(ConnectionIndicator, { alwaysVisible: showConnectionIndicator, enableStatsDisplay: true, iconSize: _indicatorIconSize, participantId: participantId, statsPopoverPosition: STATS_POPOVER_POSITION[thumbnailType] })))));
};
export default ThumbnailTopIndicatorsMobile;
